var _excluded = ["clearable", "clearIcon", "changeOnBlur", "dateFormat", "error", "fluid", "loading", "inputReadOnly", "nextIcon", "prevIcon", "superNextIcon", "superPrevIcon", "suffixIcon", "showTime", "transparent"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import Picker from 'rc-picker';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import 'dayjs/locale/fr';
import classNames from 'classnames';
import { useKey } from '@jvs-group/jvs-mairistem-tools';
import { ClearIcon, NextIcon, PrevIcon, SuffixIcon, SuperNextIcon, SuperPrevIcon } from "./Icons";
import frFR from "./locale/fr_FR";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Pour sélectionner ou saisir une date uniquement.
 */
var SingleDatePicker = function SingleDatePicker(props) {
  var _props$clearable = props.clearable,
    clearable = _props$clearable === void 0 ? false : _props$clearable,
    _props$clearIcon = props.clearIcon,
    clearIcon = _props$clearIcon === void 0 ? /*#__PURE__*/_jsx(ClearIcon, {}) : _props$clearIcon,
    _props$changeOnBlur = props.changeOnBlur,
    changeOnBlur = _props$changeOnBlur === void 0 ? true : _props$changeOnBlur,
    dateFormat = props.dateFormat,
    _props$error = props.error,
    error = _props$error === void 0 ? false : _props$error,
    _props$fluid = props.fluid,
    fluid = _props$fluid === void 0 ? false : _props$fluid,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    _props$inputReadOnly = props.inputReadOnly,
    inputReadOnly = _props$inputReadOnly === void 0 ? false : _props$inputReadOnly,
    _props$nextIcon = props.nextIcon,
    nextIcon = _props$nextIcon === void 0 ? /*#__PURE__*/_jsx(NextIcon, {}) : _props$nextIcon,
    _props$prevIcon = props.prevIcon,
    prevIcon = _props$prevIcon === void 0 ? /*#__PURE__*/_jsx(PrevIcon, {}) : _props$prevIcon,
    _props$superNextIcon = props.superNextIcon,
    superNextIcon = _props$superNextIcon === void 0 ? /*#__PURE__*/_jsx(SuperNextIcon, {}) : _props$superNextIcon,
    _props$superPrevIcon = props.superPrevIcon,
    superPrevIcon = _props$superPrevIcon === void 0 ? /*#__PURE__*/_jsx(SuperPrevIcon, {}) : _props$superPrevIcon,
    suffixIconProps = props.suffixIcon,
    showTime = props.showTime,
    _props$transparent = props.transparent,
    transparent = _props$transparent === void 0 ? false : _props$transparent,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var suffixIcon = suffixIconProps != null ? suffixIconProps : /*#__PURE__*/_jsx(SuffixIcon, {
    type: showTime ? 'time' : 'date'
  });

  /**
   * Render de l'input du picker.
   */
  var renderInput = React.useCallback(function (pickerProps) {
    return /*#__PURE__*/_jsxs("div", {
      className: classNames('ui input', useKey(clearable, 'clearable'), useKey(error, 'error'), useKey(fluid, 'fluid'), useKey(inputReadOnly, 'readonly'), useKey(loading, 'loading'), useKey(transparent, 'transparent'), useKey(!_.isEmpty(suffixIcon), 'icon')),
      children: [/*#__PURE__*/_jsx("input", Object.assign({}, pickerProps, {
        readOnly: inputReadOnly,
        type: "text"
      })), suffixIcon]
    });
  }, [clearable, error, fluid, inputReadOnly, loading, suffixIcon, transparent]);
  var allowClear = React.useMemo(function () {
    return clearable ? {
      clearIcon: clearIcon
    } : false;
  }, [clearIcon, clearable]);

  // On prend le dateFormat si défini,
  // Sinon si c'est juste un picker date on formate avec 'DD/MM/YYYY'
  // et si c'est un picker datetime, on formate avec 'DD/MM/YYYY - HH:mm:ss'
  var format = React.useMemo(function () {
    return dateFormat != null ? dateFormat : _.isNil(showTime) ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm:ss';
  }, [dateFormat, showTime]);

  // Toutes les props optionnelles du picker
  // que nous initialisons avec des valeurs dans notre cas
  var optionnalPickerProps = React.useMemo(function () {
    return {
      allowClear: allowClear,
      changeOnBlur: changeOnBlur,
      className: classNames('field', useKey(fluid, 'fluid')),
      format: format,
      inputRender: renderInput,
      prefixCls: 'ui-picker',
      prevIcon: prevIcon,
      superPrevIcon: superPrevIcon,
      nextIcon: nextIcon,
      superNextIcon: superNextIcon,
      showTime: showTime
    };
  }, [allowClear, changeOnBlur, fluid, format, renderInput, prevIcon, superPrevIcon, nextIcon, superNextIcon, showTime]);
  return /*#__PURE__*/_jsx(Picker, Object.assign({
    generateConfig: dayjsGenerateConfig,
    locale: Object.assign({}, frFR.lang)
  }, optionnalPickerProps, rest));
};
SingleDatePicker.handledProps = [];
export default SingleDatePicker;